import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Select } from 'antd';
import axios from "axios";
import { VehicleTypeCategoryEnum } from "../routes/vehicleTypes/api/Representation";
import { axiosErrorHandler } from "../../../swzutils";
const VehicleTypeCategorySelect = ({ disabled = false, defaultValue, value, mode, allowClear = true, placeholder = "Vehicle category", style, onChange }) => {
    const [options, setOptions] = useState([]);
    useEffect(() => {
        loadVehicleTypeCategories();
    }, []);
    const onCategoriesLoaded = (categories) => {
        setOptions(categories.map(category => {
            return {
                label: category.description,
                value: category.name
            };
        }));
    };
    const loadVehicleTypeCategories = () => {
        axios.get('/admin/v1/vehicle-types/categories')
            .then(response => onCategoriesLoaded(response.data))
            .catch(axiosErrorHandler);
    };
    return (_jsx(Select, { mode: mode, disabled: disabled, allowClear: allowClear, placeholder: placeholder, style: style, onChange: onChange, value: value, defaultValue: defaultValue, showSearch: {
            optionFilterProp: ['label']
        }, options: options }));
};
export default VehicleTypeCategorySelect;
